<template>
  <div>
    <div class="page-wrap">
      <h2 class="title-page fw-500">
        <i class="fas fa-book mr-2"></i>สรุปข้อมูลรายการฝาก
      </h2>
      <!-- <p>สเตทเม้นธนาคารรายการฝาก-ถอน</p> -->
      <!-- <div class="row">
        <div class="col-md-3">
          <div class="bttn-pri-wrap activebttn">
            <i class="fas fa-book"></i>สเตทเม้นธนาคารบัญชีฝาก
          </div>
        </div>
        <div class="col-md-3">
        <router-link to="AccountDeposit">
          <div class="bttn-pri-wrap">
            <i class="fas fa-book"></i>ข้อมูลบัญชีฝาก
          </div>
        </router-link>
        </div>
        <div class="col-md-3">
        <router-link to="AddAccountDeposit">
          <div class="bttn-pri-wrap">
            <i class="fas fa-plus"></i>เพิ่มข้อมูลบัญชีฝาก
          </div>
        </router-link>
        </div>
      </div> -->
      <div class="body-content">
        <p class="mt-3">แสดงรายการฝาก</p>
        <div class="row">
          <div class="col-md-4">
            <date-picker
              class="input-date w-100"
              valueType="format"
              type="date"
              lang="en"
              v-model="payload.date"
              v-on:change="onchange"
            ></date-picker>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <select
                class="browser-default custom-select input-data input-default"
                name="selectbank"
                v-on:change="onchangeSelectbank($event)"
              >
                <option disabled value="null" selected>
                  เลือกบัญชี
                </option>
                <option
                  v-for="(data, key) in selectbank"
                  :key="key"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <!-- <div class="form-group mb-0">
                <select class="form-control" id="exampleFormControlSelect1">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div> -->
              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="defaultCheck1"
                />
                <label class="form-check-label" for="defaultCheck1">
                  แสดงเฉพาะเพิ่มรายการฝาก
                </label>
              </div> -->
            </div>
          </div>
        </div>
        <div class="table-content">
          <mdb-datatable
            :arrows="true"
            :data="tableData"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="450px"
            v-if="reloading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var axios = require("axios");
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      reloading: false,
    //   dateselect1: "",
      selectbank: [],
      payload: {
        date: moment().format("YYYY-MM-DD"),
        bank_number: "",
      },
      tableData: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "วันที่",
            field: "date",
            sort: true,
          },
          {
            label: "username",
            field: "username",
            sort: true,
          },
          {
            label: "จำนวนเงิน",
            field: "amount",
            sort: true,
          },
          {
            label: "โปรโมชั่น",
            field: "promotion_name",
            sort: true,
          },
           {
            label: "ก่อนฝาก",
            field: "brefore",
            sort: true,
          },
           {
            label: "หลังฝาก",
            field: "after",
            sort: true,
          },
          {
            label: "เครดิต",
            field: "credit",
            sort: true,
          },
          {
            label: "status",
            field: "status",
            sort: true,
            format:(value)=>{
 return (
                `<div class="text-center btnbtn" style="max-width:110px;" data-status="${value === 1 ?'true':'false'}">
                <label class=" text-white font14"  style="cursor: pointer;background-color:${value === 1 ?'#00D717':'#FFD700'};border-radius:6px;">
                    <p class="mb-0" style="font-size:0.6rem;padding:2px 6px;">${value === 1 ?'สำเร็จ':'กำลังทำรายการ'}</p>
                </label>
                </div>`)
            },
          },
        ],
        rows: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
    data() {
      return {
        columns: [],
        rows: [],
      };
    },
  },
  //   async mounted() {
  //     this.getBankList();
  //   },
  async mounted() {
    this.reloading = true;
    this.getBankList();
    this.getStatementByBank();
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    filterData(dataArr, keys) {
      let data = dataArr.map((entry) => {
        let filteredEntry = {};
        keys.forEach((key) => {
          if (key in entry) {
            filteredEntry[key] = entry[key];
          }
        });
        return filteredEntry;
      });
      return data;
    },
    async checkValue() {},
    async getBankList() {
      var config = {
        method: "get",
        url: "https://sms-fast.warmlight.online/api/getBankList",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: "",
      };
      await axios(config)
        .then((response) => {
          this.selectbank = response.data.payload.map((item) => {
            return {
              value: item.bank_number,
              text: `${item.bank_name}(${item.bank_code})`,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async onchange() {
      this.getStatementByBank();
    },
    onchangeSelectbank(e) {
      this.payload.bank_number = e.target.value;
      this.onchange();
    },
    async getStatementByBank() {
      this.tableData.rows = null;
      const token = jwt.sign(this.payload, this.$keypayload);
      var config = {
        method: "POST",
        url: "https://sms-fast.warmlight.online/api/getDepositAll",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: { token: token },
      };
      await axios(config)
        .then((response) => {
          let result = [];

          if (response.data.payload && response.data.payload.length > 0) {
            for (const dataapi of response.data.payload) {
              let datadata = {
                date: dataapi.date,
                username: dataapi.username,
                amount: dataapi.amount,
                promotion_name: dataapi.promotion_name,
                status: dataapi.status,
                brefore: dataapi.brefore,
                after:dataapi.after,
                credit: dataapi.credit,
             
              };
              result.push(datadata);
            }
          }

          this.tableData.rows = this.$add_index(result);
          this.reloading = false;

          this.$nextTick(() => {
            this.reloading = true;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>

</style>
